import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFileTif.tsx
const IconFileTif = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "#ece5e3",
			d: "M2 2h11.5v4A1.5 1.5 0 0 0 15 7.5h4V8h-9a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h9v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#ece5e3",
			d: "M14.5 2.5V6a.5.5 0 0 0 .5.5h3.5z"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#93a813",
			fillRule: "evenodd",
			d: "M10 9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm5.039 5.364v.726h1.992v-.726h-.54v-2.736h.54v-.726h-1.992v.726h.54v2.736zm-1.573-2.652v3.378h-.912v-3.378H11.42v-.81h3.18v.81zm4.324-.81v4.188h.912v-1.716h1.59v-.804h-1.59v-.858h1.866v-.81z",
			clipRule: "evenodd"
		})
	]
});
var IconFileTif_default = forwardRef(IconFileTif);
//#endregion
export { IconFileTif_default as default };
